/* @flow */
import { css } from 'linaria';

import MediaQueries from './MediaQueries';

export const RESPONSIVE_FONT_SIZE_STYLES = {
  '8': {
    small: css`
      font-size: 8px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 8px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 8px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 8px;
      }
    `,
  },
  '11': {
    small: css`
      font-size: 11px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 11px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 11px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 11px;
      }
    `,
  },
  '12': {
    small: css`
      font-size: 12px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 12px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 12px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 12px;
      }
    `,
  },
  '13': {
    small: css`
      font-size: 13px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 13px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 13px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 13px;
      }
    `,
  },
  '14': {
    small: css`
      font-size: 14px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 14px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 14px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 14px;
      }
    `,
  },
  '15': {
    small: css`
      font-size: 15px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 15px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 15px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 15px;
      }
    `,
  },
  '16': {
    small: css`
      font-size: 16px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 16px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 16px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 16px;
      }
    `,
  },
  '17': {
    small: css`
      font-size: 17px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 17px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 17px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 17px;
      }
    `,
  },
  '18': {
    small: css`
      font-size: 18px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 18px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 18px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 18px;
      }
    `,
  },
  '20': {
    small: css`
      font-size: 20px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 20px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 20px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 20px;
      }
    `,
  },
  '21': {
    small: css`
      font-size: 21px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 21px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 21px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 21px;
      }
    `,
  },
  '22': {
    small: css`
      font-size: 22px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 22px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 22px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 22px;
      }
    `,
  },
  '24': {
    small: css`
      font-size: 24px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 24px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 24px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 24px;
      }
    `,
  },
  '26': {
    small: css`
      font-size: 26px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 26px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 26px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 26px;
      }
    `,
  },
  '28': {
    small: css`
      font-size: 28px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 28px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 28px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 28px;
      }
    `,
  },
  '32': {
    small: css`
      font-size: 32px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 32px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 32px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 32px;
      }
    `,
  },
  '40': {
    small: css`
      font-size: 40px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 40px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 40px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 40px;
      }
    `,
  },
  '48': {
    small: css`
      font-size: 48px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 48px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 48px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 48px;
      }
    `,
  },
  '56': {
    small: css`
      font-size: 56px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 56px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 56px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 56px;
      }
    `,
  },
  '80': {
    small: css`
      font-size: 80px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        font-size: 80px;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        font-size: 80px;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        font-size: 80px;
      }
    `,
  },
};

export const RESPONSIVE_TEXT_ALIGN_STYLES = {
  left: {
    small: css`
      text-align: left;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        text-align: left !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        text-align: left !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        text-align: left !important;
      }
    `,
  },
  right: {
    small: css`
      text-align: right;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        text-align: right !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        text-align: right !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        text-align: right !important;
      }
    `,
  },
  center: {
    small: css`
      text-align: center;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        text-align: center !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        text-align: center !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        text-align: center !important;
      }
    `,
  },
  inherit: {
    small: css`
      text-align: inherit;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        text-align: inherit !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        text-align: inherit !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        text-align: inherit !important;
      }
    `,
  },
};



// WEBPACK FOOTER //
// ./src/ui/constants/ResponsiveText.js